import { useMutation } from '@tanstack/react-query';

import { queryClient } from '~app/query-client';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

import { type TransactionCode } from './get-transaction-codes';

export interface CreateTransactionCode {
  code: string;
  description: string;
  sessionId?: string;
  sessionName?: string;
  entities?: Array<Entity>;
  isAllClassSelected?: boolean;
}

export interface Entity {
  entityId: string;
  entityName: string;
}

export const createTransactionCode = async (params: CreateTransactionCode) => {
  const response = await baseAPI.post<TransactionCode>('transaction-code', {
    ...params,
  });
  return response.data;
};

export const useCreateTransactionCode = () => {
  return useMutation({
    mutationFn: (params: CreateTransactionCode) =>
      createTransactionCode(params),

    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: [KEYS.TRANSACTION_CODE],
      });
    },
  });
};
